const steps = [
  {
    number: '1',
    title: 'Request a Quote',
    description: "Fill out our simple form or give us a call. We'll respond within 24 hours with a free, no-obligation quote."
  },
  {
    number: '2',
    title: 'We Clean',
    description: 'Our professional team arrives on schedule with all supplies. Sit back while we make your workspace sparkle.'
  },
  {
    number: '3',
    title: 'You Relax',
    description: "Enjoy your spotless office! Not satisfied? We'll make it right with our 100% satisfaction guarantee."
  }
];

export default function HowItWorks() {
  return (
    <section className="py-28 px-6 bg-white">
      <div className="max-w-[1080px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-[88px]">
          <p className="text-[13px] font-bold tracking-[0.09em] uppercase text-[#0b5b96] mb-[14px]">Simple Process</p>
          <h2 className="font-extrabold text-[#161a20] tracking-tight" style={{ fontSize: 'clamp(2.25rem,4vw,3rem)' }}>How It Works</h2>
        </div>

        {/* Steps */}
        <div className="grid gap-12 relative" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))' }}>
          <div className="hidden md:block absolute top-10 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-[#dde1e7] to-transparent"></div>
          {steps.map((step, index) => (
            <div key={index} className="text-center relative">
              <div className="relative inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#0b5b96] text-white text-[30px] font-extrabold mb-[26px] shadow-[0_12px_26px_-10px_rgba(11,91,150,0.5)] z-[1]">
                {step.number}
                <div className="absolute inset-0 rounded-full bg-[#0b5b96] animate-fr-pulse"></div>
              </div>
              <h3 className="text-[22px] font-bold text-[#161a20] mb-3">{step.title}</h3>
              <p className="text-[15.5px] leading-relaxed text-[#5b6472] max-w-[280px] mx-auto">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
